(function Module() {
	'use strict';

	mySynch.controller('TechniciansDashboardController', [
		'$scope',
		'MySynchFactory',
		'ApiFactory',
		'clientLoggerService',
		function TechniciansDashboardController($s, MSF, api, log) {
			var self = this;
			self.loading = true;
			self.technicianReportRows = [];
			self.dataUpdatedDate = null;
			self.isTotalRow = breederRowIsTotal;
			self.concepDataCode = "CR-byTech";

			function formattedRate(rate) {
				return _.isNumber(rate) ? _.round(rate * 100, 1) + '%' : rate;
			}

			function formattedDecimal(val) {
				return (!_.isNumber(val) || _.isNaN(val)) ? val : _.round(val, 1);
			}

			function formatTechnicianReportLineItems(techLineItems) {
				var breederName		= _.trim(_.get(techLineItems, 'code'));
				var confInterval    = _.trim(_.get(techLineItems,'cI_95_display',""));
				var conceptionRate	= _.get(techLineItems, 'concPerc',	0);
				var pregnancyCount	= _.get(techLineItems, 'pregCount',	0);
				var openCount		= _.get(techLineItems, 'openCount',			0);
				var otherCount		= _.get(techLineItems, 'otherCount',		0);
				var abortCount		= _.get(techLineItems, 'abortCount',		0);
				var totalCount		= _.get(techLineItems, 'totalCount',		0);
				var percentOfTotal	= _.get(techLineItems, 'totalPerc',	0);
				var servicesPerConception = _.get(techLineItems, 'servicesPerConcep', 0);

				var formattedRowData = {
					breederName:	breederName,
					confInterval: confInterval,
					conceptionRate: formattedRate(conceptionRate),
					pregnancyCount: pregnancyCount,
					openCount:		openCount,
					otherCount:		otherCount,
					abortCount:		abortCount,
					totalCount:		totalCount,
					percentOfTotal: formattedRate(percentOfTotal),
					servicesPerConception: formattedDecimal(servicesPerConception)
				};

				return formattedRowData;
			}

			function breederRowIsTotal(row) {
				return row.breederName.toLowerCase() === 'totals';
			}

			function breederRowIsOther(row) {
				return row.breederName.toLowerCase() === 'others';
			}

			function loadTechnicianReportData() {
				self.loading				= true;
				self.technicianReportRows	= [];
				self.incompleteSetupMessage = '';

				var herdId = MSF.getActiveHerd().herdId;

				api.getHerdConcepDataByCodeAndHerdId(herdId,self.concepDataCode, function gotTechnicianReportData(err, results) {
					self.loading = false;

					if (err) {
						self.technicianReportRows = [];
						log.error({error: err}, 'Error getting breeder fertility data');

						if (results.statusCode === 403) { // 403 indicates setup is not complete and should have display message in response
							self.incompleteSetupMessage = results.statusText;
						}

						return;
					}

					var reportData = results;

					var formattedRows		= _.map(reportData, formatTechnicianReportLineItems);
					var totalRow			= _.remove(formattedRows, breederRowIsTotal);
					var otherRow			= _.remove(formattedRows, breederRowIsOther);
					var sortedRows			= _.sortBy(formattedRows, 'breederName');

					self.technicianReportRows = sortedRows.concat(otherRow).concat(totalRow);

				});
			}

			MSF.ready(function onMsfReady() {
				
				var currentActiveHerdId = _.get(MSF.getActiveHerd(), 'herdId');
				var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(currentActiveHerdId);
                var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
                self.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(MSF.i18n.format.dateLong) : '';
				loadTechnicianReportData();

				$s.$on('herd:changed', function herdChanged() {
					
					var currentActiveHerdId = _.get(MSF.getActiveHerd(), 'herdId');
					var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(currentActiveHerdId);
					var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
					self.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(MSF.i18n.format.dateLong) : '';
					loadTechnicianReportData();
				});
			});

			// Code supporting the display of reasons for 403 when viewing dashboard
			self.incompleteSetupMessage = '';
			self.setupIsIncomplete			= function setupIsIncomplete() {
				return self.incompleteSetupMessage !== '';
			};
			self.getIncompleteSetupMessages = function getIncompleteSetupMessages() {
				return self.incompleteSetupMessage.split('|');
			};
			self.getTerritoryManager		= function getTerritoryManager() {
				return MSF.getActiveFarmTerritoryManager();
			};
			// Add these to the scope so they are visible to the mixin
			$s.setupIsIncomplete			= self.setupIsIncomplete;
			$s.getIncompleteSetupMessages	= self.getIncompleteSetupMessages;
			$s.getTerritoryManager			= self.getTerritoryManager;
		}
	]);
})();
